var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34.035 34.035",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.85 27.2c0 .097-.08.176-.176.176H7.33a.177.177 0 0 1-.177-.176V8.856c0-.097.08-.176.177-.176h8.995c.097 0 .177.08.177.176v1.411c0 .097-.08.177-.177.177H9.094a.177.177 0 0 0-.177.176v14.816c0 .097.08.176.177.176H23.91a.176.176 0 0 0 .176-.176v-7.232c0-.097.08-.176.176-.176h1.412c.097 0 .176.08.176.176zm2.35-11.65c0 .097-.08.176-.176.176h-1.412a.177.177 0 0 1-.176-.176V8.405a.177.177 0 0 0-.176-.176h-7.145a.177.177 0 0 1-.176-.176V6.642c0-.097.08-.177.176-.177h8.909c.097 0 .176.08.176.177z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 19.73a.177.177 0 0 1-.25 0l-.997-.998a.177.177 0 0 1 0-.25L26.57 6.857a.177.177 0 0 1 .25 0l.997.998a.177.177 0 0 1 0 .25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/External_Link.7ae231c89042ea714f553c5ebd0261c8.svg";
export { ForwardRef as ReactComponent };